import { Link } from '@inertiajs/react'

interface User {
  id: string
  username: string
  admin: boolean
}

interface HeaderProps {
  currentUser?: User | null
}

export default function Header({ currentUser }: HeaderProps) {
  return (
    <header className="bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-12">
          <Link href="/" className="font-medium hover:opacity-80 transition-opacity">
            three.pm
          </Link>

          <nav className="flex items-center gap-4">
            {currentUser ? (
              <>
                {currentUser.username === 'alexbaldwin' && (
                  <Link href="/posts/new" className="text-sm hover:opacity-80 transition-opacity">
                    + New post
                  </Link>
                )}
                <Link href="/messages/chat" className="text-sm hover:opacity-80 transition-opacity">
                  Chat
                </Link>
                <Link
                  href={`/${currentUser.username}`}
                  className="text-sm hover:opacity-80 transition-opacity"
                >
                  Profile
                </Link>
                <Link
                  href={`/users/${currentUser.username}/edit`}
                  className="text-sm hover:opacity-80 transition-opacity"
                >
                  Settings
                </Link>
                <Link
                  href="/sign_out"
                  method="get"
                  className="text-sm hover:opacity-80 transition-opacity"
                >
                  Sign Out
                </Link>
              </>
            ) : (
              <Link href="/users/sign_in" className="text-sm hover:opacity-80 transition-opacity">
                Sign in
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}
